import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, Input } from "@angular/core";
import { NodeViewModel } from "../../webhook-interfaces/node";
import { Version } from "../webhook-edit.component";
import { DebugInterface } from "../../webhook-services/webhook-debug.services";
import { NzModalService } from "ng-zorro-antd/modal";
import { WebhookDebugLogItemComponent } from "../webhook-debug-log/webhook-debug-log-item/webhook-debug-log-item.component";
import { LanguageServices } from "src/app/services/LanguageServices";

@Component({
    selector: 'webhook-node',
    templateUrl: './webhook-edit-node.component.html',
    styleUrl: './webhook-edit-node.component.scss',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class WebhookEditNodeComponent implements AfterViewInit {

    constructor(protected ls:LanguageServices, protected modal:NzModalService) {

    }

    @Input() node: NodeViewModel | undefined;
    @Input() color:string = '#ffffff';
    @Input() selectedVersion:Version;
    @Input() debug:boolean = false;
    @Input() debugging:DebugInterface;
    
    ngAfterViewInit(): void {
            
    }

    onHandleMouseDown(event: MouseEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    killGroup(event, node:NodeViewModel){
        event.preventDefault();
        event.stopPropagation();
        node.parentId=null;
    }

    getDebuggingLog(){
        let object = {
            resultList:[],
            error:false,
        }

        if ( this.debugging!= null && this.debugging.log != null){
            Object.keys(this.debugging.log).forEach(key=>{
                if ( key == this.node.key ){
                    if ( this.debugging.log[key] instanceof Array){
                        this.debugging.log[key].forEach(data=>{
                            object.resultList.push(data);
                            if (data.result && data.result instanceof Array){
                                data.result.forEach(r=>{
                                    
                                    if ( !r.success ){
                                        object.error = true;
                                    }
                                })
                            }
                        })
                    }
                }
            });
        }
        return object;
    }

    openResult(object){
        
        this.modal.create({
            nzTitle: this.ls.instant('webhook.debug.log.item.title', {idjob:this.debugging.idjob, key:this.node.key}),
            nzContent: WebhookDebugLogItemComponent,
            nzWidth: '80%',
            nzBodyStyle: { overflow: 'auto', maxHeight: 'calc(80vh - 100px)' },
            nzMaskClosable: false,
            nzKeyboard: false,
            nzClosable: true,
            nzData: {
                flowData: object,
            },
            nzFooter:null,
            nzCentered: true                
        });
    }

}